// Distinguish between jQueryUI Datepicker and bootstrap-datepicker
(function () {
    var datepicker = $.fn.datepicker.noConflict();
        $.fn.bootstrapDP = datepicker;

    // Fix for: https://www.pivotaltracker.com/story/show/156727848
    //
    // The datepicker widget can be left behind if the triggering date input
    // is destroyed.  This can happen when the underlying page is rerendered.
    //
    // The fix is to initialise the widget with a 'container' that will be
    // destroyed along with the date input (usually a parent div).  The
    // widget is then created as a child of the container rather than the
    // body (the default).  This ensures it is destroyed along with the
    // triggering date input.
    //
    // This exposed a bug in the upstream version of the library that relates
    // to the positioning of the widget once opened. The monkey patching
    // below corrects the bug.
    //
    // The upstream library is not very active, there are numerous reports of
    // this bug along with pull requests to fix it.  So far the maintainers
    // of the library have done nothing.  I have also created a pull request
    // and have starred the library on github.  When/if they fix this bug I
    // will be notified and we can remove this code.
        $.fn.bootstrapDP.Constructor.prototype.place = function() {
                if (this.isInline) return this;
                var calendarWidth = this.picker.outerWidth(),
                        calendarHeight = this.picker.outerHeight(),
                        visualPadding = 10,
                        container = $(this.o.container),
                        windowWidth = container.width(),
                        scrollTop = this.o.container === 'body' ? $(document).scrollTop() : container.scrollTop(),
                        appendOffset = container.offset();

                var parentsZindex = [0];
                this.element.parents().each(function(){
                        var itemZIndex = $(this).css('z-index');
                        if (itemZIndex !== 'auto' && Number(itemZIndex) !== 0) parentsZindex.push(Number(itemZIndex));
                });
                var zIndex = Math.max.apply(Math, parentsZindex) + this.o.zIndexOffset;
                var offset = this.component ? this.component.parent().offset() : this.element.offset();
                var height = this.component ? this.component.outerHeight(true) : this.element.outerHeight(false);
                var width = this.component ? this.component.outerWidth(true) : this.element.outerWidth(false);
                var left = offset.left;
                var top = offset.top;

                if (this.o.container !== 'body') {
                        top += scrollTop;
                }

                this.picker.removeClass('datepicker-orient-top datepicker-orient-bottom datepicker-orient-right datepicker-orient-left');

                if (this.o.orientation.x !== 'auto'){
                        this.picker.addClass('datepicker-orient-' + this.o.orientation.x);
                        if (this.o.orientation.x === 'right')
                                left -= calendarWidth - width;
                }
                // auto x orientation is best-placement: if it crosses a window
                // edge, fudge it sideways
                else {
                        if (offset.left - calendarWidth < 0) {
                                // component is outside the window on the left side. Move it into visible range
                                this.picker.addClass('datepicker-orient-left');
                                //left -= offset.left - visualPadding;
                        } else if (left + calendarWidth > windowWidth) {
                                // the calendar passes the widow right edge. Align it to component right side
                                this.picker.addClass('datepicker-orient-right');
                                left += width - calendarWidth;
                        } else {
                                if (this.o.rtl) {
                                        // Default to right
                                        this.picker.addClass('datepicker-orient-right');
                        } else {
                                // Default to left
                                this.picker.addClass('datepicker-orient-left');
                        }
                  }
                }

                // auto y orientation is best-situation: top or bottom, no fudging,
                // decision based on which shows more of the calendar
                var yorient = this.o.orientation.y,
                        top_overflow;
                if (yorient === 'auto') {
                        top_overflow = -scrollTop + top - calendarHeight -62;
                        yorient = top_overflow < 0 ? 'bottom' : 'top';
                }

                this.picker.addClass('datepicker-orient-' + yorient);
                if (yorient === 'top')
                        top -= calendarHeight + parseInt(this.picker.css('padding-top'));
                else
                        top += height;

                if (this.o.rtl) {
                        var right = windowWidth - (left + width);
                        this.picker.css({
                                top: top,
                                right: right,
                                zIndex: zIndex
                  });
                } else {
                        this.picker.css({
                                top: top,
                                left: left,
                                zIndex: zIndex
                  });
                }
                return this;
          };
})();

//
// TODO Include this from the locale-files in the bower-package instead
(function($){
        $.fn.bootstrapDP.dates['sv'] = {
                days: ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag"],
                daysShort: ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"],
                daysMin: ["Sö", "Må", "Ti", "On", "To", "Fr", "Lö"],
                months: ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"],
                monthsShort: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
                today: "Idag",
                format: "yyyy-mm-dd",
                weekStart: 1,
                clear: "Rensa"
        };
        $.datepicker.regional['sv'] = {
		monthNames: ['Januari','Februari','Mars','April','Maj','Juni','Juli','Augusti','September','Oktober','November','December'],
		monthNamesShort: ['Jan','Feb','Mar','Apr','Maj','Jun','Jul','Aug','Sep','Okt','Nov','Dec'],
		dayNamesShort: ['Sön','Mĺn','Tis','Ons','Tor','Fre','Lör'],
		dayNames: ['Söndag','Mĺndag','Tisdag','Onsdag','Torsdag','Fredag','Lördag'],
		dayNamesMin: ['Sö','Mĺ','Ti','On','To','Fr','Lö']
        };
        $.fn.bootstrapDP.dates['no'] = {
                days: ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"],
                daysShort: ["Søn", "Man", "Tir", "Ons", "Tor", "Fre", "Lør"],
                daysMin: ["Sø", "Ma", "Ti", "On", "To", "Fr", "Lø"],
                months: ["Januar", "Februar", "Mars", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Desember"],
                monthsShort: ["Jan", "Feb", "Mar", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Des"],
                today: "I dag",
                format: "yyyy-mm-dd",
                weekStart: 1,
                clear: "Tøm"
        };
        $.datepicker.regional['no'] = {
                monthNames: ['Januar','Februar','Mars','April','Mai','Juni','Juli','August','September','Oktober','November','Desember'],
                monthNamesShort: ['Jan','Feb','Mar','Apr','Mai','Jun','Jul','Aug','Sep','Okt','Nov','Des'],
                dayNamesShort: ['Søn','Man','Tir','Ons','Tor','Fre','Lør'],
                dayNames: ['Søndag','Mandag','Tirsdag','Onsdag','Torsdag','Fredag','Lørdag'],
                dayNamesMin: ['Sø','Ma','Ti','On','To','Fr','Lø']
        };
}(jQuery));

function initialiseDatePickers(elements) {
        elements.each(function(index) {
                var elem = $(this);
                var options = {
                        weekStart: 1,
                        calendarWeeks: true,
                        assumeNearbyYear: true,
                        todayHighlight: true,
                        language: Core.language,
                        autoclose: true,
                        format: "yyyy-mm-dd",
                        container: elem.attr('data-date-container') || elem.closest('.form-horizontal, .controls, .container, body')
                };
                elem.bootstrapDP(options)
        });
}

function initialiseMonthPickers(elements, startDate, endDate){
        elements.each(function(index) {
                var elem = $(this);
                var options = {
                        startDate: startDate,
                        endDate: endDate,
                        language: Core.language,
                        autoclose: true,
                        todayHighlight: true,
                        format: "MM yyyy",
                        startView: 'months',
                        minViewMode: 'months',
                        container: elem.attr('data-date-container') || elem.closest('.form-horizontal, .controls, .container, body')
                };
                elem.bootstrapDP(options)
        });
}

function initialisePayrollPickers(elements){
        elements.each(function(index) {
                var elem = $(this);
                var options = {
                        language: Core.language,
                        autoclose: true,
                        todayHighlight: true,
                        format: "dd",
                        startView: 'days',
                        minViewMode: 'days',
                        container: elem.attr('data-date-container') || elem.closest('.form-horizontal, .controls, .container, body')
                };
                elem.bootstrapDP(options)
        });
}